import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { createPortal } from "react-dom";
import stl from "./SharedPopUp.module.css";
import SharedPopUpBody from "./SharedPopUpBody";
var SharedPopUp = function SharedPopUp(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    className = _ref.className,
    maxWidth = _ref.maxWidth,
    oowh = _ref.oowh,
    hideCloseBtn = _ref.hideCloseBtn,
    children = _ref.children;
  useEffect(function () {
    if (typeof document !== 'undefined') {
      if (show) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return function () {
        document.body.style.overflow = "";
      };
    }
  }, [show]);
  var renderPopUpHTML = function renderPopUpHTML() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("div", {
      className: [stl.genralPopUp, stl.showGenralPopUp, className].join(" "),
      onClick: function onClick(e) {
        if (e.target === e.currentTarget) {
          onClose();
          document.body.style.overflow = "";
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : "100%"
      },
      className: [stl.genralPopUpContent, oowh && stl.changeMinHeight].join(" ")
    }, !hideCloseBtn && /*#__PURE__*/React.createElement("span", {
      className: stl.closeGenralPopUp,
      onClick: function onClick() {
        onClose();
        document.body.style.overflow = "";
      }
    }), /*#__PURE__*/React.createElement(SharedPopUpBody, null, children))));
  };
  if (typeof document === 'undefined') {
    return null;
  } else {
    return /*#__PURE__*/createPortal(renderPopUpHTML(), document.getElementById("BodyPortal"));
  }
};
export default SharedPopUp;